import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { ChecklistStageData } from '../checklistData';
import { StageStats } from '../checklistUtils';
import { colors } from '../../../../theme';

// primary-ash-400 (Figma) — used for incomplete step icons and the dotted connectors.
const ASH_400 = '#C6B7E6';

function StageStepper({ stages, stats }: { stages: ChecklistStageData[]; stats: StageStats[] }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
      {stages.map((stage, i) => {
        const s = stats[i];
        const complete = s.done === s.total;
        const isLast = i === stages.length - 1;
        return (
          <Box
            key={stage.id}
            sx={{
              flex: 1, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center',
            }}
          >
            {!isLast && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '14px',
                  left: 'calc(50% + 20px)',
                  right: 'calc(-50% + 20px)',
                  height: 0,
                  borderTop: complete ? `4px solid ${colors.primary.main}` : `4px dotted ${ASH_400}`,
                }}
              />
            )}
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: complete ? colors.primary.main : '#fff',
                border: `2px solid ${complete ? colors.primary.main : ASH_400}`,
              }}
            >
              <CheckIcon sx={{ fontSize: 17, color: complete ? '#fff' : ASH_400 }} />
            </Box>
            <Box sx={{ textAlign: 'center', mt: 1, px: 0.5 }}>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 12, md: 13 },
                  whiteSpace: 'nowrap',
                  color: complete ? colors.primary.main : 'text.primary',
                }}
              >
                {stage.range}
              </Typography>
              <Typography sx={{ fontSize: { xs: 11, md: 12 }, color: 'text.secondary', mt: 0.125 }}>
                {stage.short}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default StageStepper;
